export enum ETestIds {
  PhoneModal = 'phoneModal',
  PhoneInput = 'phoneInput',
  EnterButton = 'enterButton',
  SmsCodeModal = 'smsCodeModal',
  SmsInput = 'smsInput',
  AgreementCheckbox = 'AgreementCheckbox',
  ConfirmButton = 'confirmButton',
}
